export default {"src":"/_next/static/media/search-gray.2e3788ff.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};